<!-- fix me -->
<template>
  <main>
    <Trail :list="[{ name: 'Reports', tag: 'Informes Técnicos' }]" />
    <Container class="container--main">
      <Title tag="h1">{{ title }}</Title>
      <Content :content="content" />
      <Suspense>
        <template #default>
          <PublicationsList :url="url" :collectionId="collectionId" />
        </template>
        <template #fallback>
          <Loader />
        </template>
      </Suspense>
    </Container>
  </main>
</template>

<script>
import Container from "@/components/ui/objects/Container";
import Trail from "@/components/common/Trail";
import Title from "@/components/ui/atoms/Title";
import Loader from "@/components/common/Loader";
import { useRoute } from "vue-router";
import { defineAsyncComponent } from "vue";
import { getPublications } from "@/publications.js";
import Content from "@/components/common/Content";

export default {
  components: {
    Loader,
    Container,
    Trail,
    Title,
    Content,
    PublicationsList: defineAsyncComponent(() =>
      import("../../components/publications/PublicationsList")
    ),
  },
  setup() {
    const route = useRoute();
    const url = process.env.VUE_APP_REGEN_API;
    let year = route.query.year;
    //const type = route.params.type;
    //const type = "articulo";
    const subtype = route.params.subtype;
    const page = route.query.page || 1;
    const articles = getPublications(process.env.VUE_APP_PREFIX)["informes"][
      subtype
    ];
    let title = articles.title;
    if (year) {
      title += ` del año ${year}`;
    }

    const collectionId = articles.collection_id;
    const content = articles.content;
    // Console.log de todos los const

    return {
      url,
      year,
      page,
      title,
      collectionId,
      content,
    };
  },
};
</script>
<style lang="scss" scoped>
.space-between {
  display: flex;
  flex-direction: column;
}
@media screen and (min-width: 768px) {
  .space-between {
    flex-direction: row;
  }
}
</style>
